import React from 'react';
import { Container, Typography, Box, Divider, Link } from '@mui/material';

const Terms = () => {
  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Typography variant="h4" gutterBottom>
        利用規約
      </Typography>

      {/* 第1条 */}
      <Typography variant="h6" gutterBottom>
        第1条（適用）
      </Typography>
      <Typography paragraph>
        本規約は、ユーザーが本アプリ（以下、「本サービス」）を利用する際のすべての行為に適用されます。
        ユーザーは、本サービスを利用することにより、本規約に同意したものとみなされます。
      </Typography>

      {/* 第2条 */}
      <Typography variant="h6" gutterBottom>
        第2条（禁止事項）
      </Typography>
      <Typography paragraph>
        ユーザーは以下の行為を行ってはなりません：
        <ul>
          <li>法令または公序良俗に違反する行為</li>
          <li>他のユーザーや第三者の権利を侵害する行為</li>
          <li>虚偽の情報を登録する行為</li>
          <li>本サービスの運営を妨害する行為</li>
          <li>不正アクセスおよびその試み</li>
        </ul>
      </Typography>

      {/* 第3条 */}
      <Typography variant="h6" gutterBottom>
        第3条（個人情報の取り扱い）
      </Typography>
      <Typography paragraph>
        本サービスでは、プライバシーポリシーに基づき、ユーザーの個人情報を適切に管理します。
        個人情報の詳細な取り扱いについては、<Link href="/policy" color="primary">プライバシーポリシー</Link>をご確認ください。
      </Typography>

      {/* 第4条 */}
      <Typography variant="h6" gutterBottom>
        第4条（広告配信とCookieの使用）
      </Typography>
      <Typography paragraph>
        本サービスでは、第三者配信による広告サービス（Google AdSense等）を利用し、ユーザーに最適な広告を表示するために
        Cookieを使用しています。これにより、過去のアクセス情報に基づいた広告が表示される場合があります。
      </Typography>
      <Typography paragraph>
        ユーザーは、<Link href="https://adssettings.google.com/" target="_blank" rel="noopener noreferrer">
        Google広告設定</Link>でパーソナライズ広告を無効にすることができます。
      </Typography>

      {/* 第5条 */}
      <Typography variant="h6" gutterBottom>
        第5条（著作権と知的財産権）
      </Typography>
      <Typography paragraph>
        本サービス内で提供されるすべてのコンテンツ（テキスト、画像、動画、プログラムなど）の著作権および知的財産権は、
        当方または正当な権利者に帰属します。無断での使用、複製、配布は固く禁じます。
      </Typography>

      {/* 第6条 */}
      <Typography variant="h6" gutterBottom>
        第6条（免責事項）
      </Typography>
      <Typography paragraph>
        本サービスは、正確性・信頼性・安全性を保証するものではありません。
        ユーザーは自己責任で本サービスを利用するものとし、当方は以下に関して一切の責任を負いません：
        <ul>
          <li>サービスの提供が中断または停止した場合</li>
          <li>サービス利用によって生じた損害</li>
          <li>第三者による不正アクセスや改ざんによる損害</li>
        </ul>
      </Typography>

      {/* 第7条 */}
      <Typography variant="h6" gutterBottom>
        第7条（規約変更について）
      </Typography>
      <Typography paragraph>
        当方は、本規約を必要に応じて変更する場合があります。
        変更後の規約は、本サービス上に表示した時点で効力を生じるものとします。
      </Typography>

      {/* お問い合わせ */}
      <Divider sx={{ my: 4 }} />
      <Typography variant="h6" gutterBottom>
        お問い合わせ
      </Typography>
      <Typography paragraph>
        本規約に関するお問い合わせは以下までお願いします：
      </Typography>
      <Link href="mailto:contact@example.com" color="primary">
        sekkeiyanosagyoubeya@gmail.com
      </Link>

      {/* 広告エリア */}
      <Box sx={{ my: 5, textAlign: 'center' }}>
        <Typography variant="body2" color="textSecondary">
          広告エリア（AdSenseコードを配置）
        </Typography>
      </Box>
    </Container>
  );
};

export default Terms;
